<div class="container">
  <div class="close-button d-flex justify-content-end mb-3">
    <button (click)="close()" type="button" class="btn">
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <p class="title">
    Input the below detail to receive an OTP to your reset password
  </p>

  @if (errorMessage) {
    <div class="error-div mb-3">
      <span>
        {{errorMessage}}
      </span>
    </div>
  }

  <form autocomplete="false" novalidate role="form">
    <div class="form-row">
      <div >
        <ng-otp-input type="number" [formCtrl]="inputCode" class="text-center"
        [config]="{length:otpLength}"></ng-otp-input>
        <!-- <div *ngIf="form.hasError('notNumber')">
        <small class="form-text text-danger">
          OTP can only be numbers
        </small>
      </div> -->
      @if (inputCode.invalid && (inputCode.dirty || inputCode.touched)) {
        <div>
          @if (inputCode.hasError('required')) {
            <div>
              <small class="form-text text-danger">
                OTP is a required field
              </small>
            </div>
          }
          @if (inputCode.hasError('minlength') || inputCode.hasError('maxlength')) {
            <div>
              <small class="form-text text-danger">
                OTP must be six digit
              </small>
            </div>
          }
          @if (inputCode.hasError('pattern')) {
            <div>
              <small class="form-text text-danger">
                OTP can only be numbers
              </small>
            </div>
          }
        </div>
      }
      <p class="form-text text-center">
        <span class="text-danger">
          {{countdownTimer}}
        </span>
        Didn't receive OTP?
        <a (click)="onConfirmEmail()" class="forgot_password">
          Confirm Email
        </a>
      </p>
    </div>
  </div>

  <button [disabled]="isLoading" type="button" class="mx-auto btn prjct-btn mt-5">
    Submit OTP
  </button>
</form>

</div>
